import React from 'react';
import './spinner.css';

const Spinner = () => {
    return (
        <div className="vh-100">
            <div className="content-loader d-flex justify-content-center align-items-center">
                <div className="spinner"></div>
            </div>
        </div>
    );
};

export default Spinner;
